import React, { useState } from "react";
import {
  consumeApi,
  setLiteral,
  isNullOrEmpty,
  fechaRecortada,
  newAmount,
  numberFormat,
  removeHtmlTags,
  sentenceFormat,
} from "../../js/helpers.js";
import { Dom7 } from "framework7";
import {
  Page,
  f7,
  Block,
  Row,
  Col,
  List,
  Navbar,
  Link,
  ListItem,
  Button,
  NavRight,
  Popup,
  AccordionContent,
  NavTitle,
  Input,
} from "framework7-react";
import "../../css/inside2.css";
import parse from "html-react-parser";
import MenuList from "./Components/menuList.jsx";
import NavbarComponent from "./Components/NavbarComponent";
import ContractList from "./Components/ContractList";
import UserInfo from "./Components/UserInfo.jsx";
import ContactSection from "./Components/ContactSection";
import NextPayments from "./Components/nextPayments.jsx";
import Documents from "./Components/documents.jsx";
import AmortizationTable from "./Components/amortizationTable.jsx";

export default class InsideApp extends React.Component {
  $$ = Dom7;

  state = {
    lsLiterales: [],
    userData: "",
    lsContracts: [],
    height: "auto",
    lsAllContracts: [],
    title: "",
    contract: {},
    configMiApp: {},
    activeButton: null,
    payments: [],
    paymentProvider: "",
    contractData: {},
    linkAmount: "",
    popUpLink: false,
    faqs: false,
    lsFaqs: [],
    popUpData: false,
    popUpContact: false,
    document: [],
    bank: [],
    installments: [],
    viewListAdvancedAmortizacion: false,
    viewPagoAdelantadoMessage: false,
    viewAbonoCapitalMessage: false,
    minAmount: 0,
    maxAmount: 0,
    viewDetail: false,
  };

  lsLiterales = "";
  user = "";
  configDomain = "";
  f7router = "";

  componentDidMount() {
    this.$$("#faqs").removeClass("modal-in").addClass("hidden");
    this.initializeData();
    const { f7router } = this.props;
    this.f7router = f7router;
  }

  initializeData = () => {
    const { lsLiterales, user, configDomain, contractId, contractData } =
      this.props;
    this.setState({ lsLiterales, contractId, contractData });
    this.user = user;
    this.configDomain = configDomain;
    this.getUserData();
    this.getContracts();
    this.getQuestions();
  };

  render() {
    return (
      /*-----------------------------MIAPP------------------------------------------*/
      <Page name="home" className="default" id="mainP">
        {/* NAVBAR */}
        <NavbarComponent
          userData={this.user}
          lsLiterales={this.state.lsLiterales}
        />

        {/* MENU */}
        <MenuList
          lsLiterales={this.state.lsLiterales}
          f7router={this.f7router}
        />

        {/* POP UP DATOS DE USUARIO */}
        <Popup
          id="user-data"
          opened={this.state.popUpData}
          onPopupClosed={() => this.setState({ popUpData: false })}
        >
          <Page>
            <Navbar>
              <NavTitle>
                <a>¡Hola!</a>
              </NavTitle>
              <NavRight>
                <Link popupClose>X</Link>
              </NavRight>
            </Navbar>
            <UserInfo
              userData={this.state.userData}
              lsLiterales={this.state.lsLiterales}
            />
          </Page>
        </Popup>

        {/* POP UP FAQS */}
        <Popup
          id="faqs"
          className={this.state.faqs ? "modal-in" : "hidden"}
          onPopupOpen={() => this.removeHiddenClass()}
          onPopupClosed={() => this.addHiddenClass()}
        >
          <Col>
            <Row className="left">
              <Col width="100" medium="80" small="90">
                <div
                  className="divSection elevation-15"
                  style={{ paddingBottom: "1em" }}
                >
                  <Row className="divTitle">
                    <Col width="85" className="">
                      <Col width="85">
                        <div>{setLiteral(this.state.lsLiterales, 101010)}</div>
                      </Col>
                    </Col>
                    <Col width="15">
                      <Link popupClose style={{ color: "white" }}>
                        X
                      </Link>
                    </Col>
                  </Row>
                  <List accordionList inset>
                    {this.state.lsFaqs && this.state.lsFaqs.length > 0
                      ? this.loopQuestions(this.state.lsFaqs)
                      : ""}
                  </List>
                </div>
              </Col>
            </Row>
          </Col>
        </Popup>

        {/* CONTACTANOS */}
        <Popup
          className="demo-popup"
          id="contact"
          opened={this.state.popUpContact}
          onPopupClosed={() => this.setState({ popUpContact: false })}
        >
          <Page>
            <Navbar>
              <NavTitle>{setLiteral(this.state.lsLiterales, 101004)}</NavTitle>
              <NavRight>
                <Link popupClose>X</Link>
              </NavRight>
            </Navbar>
            <ContactSection
              configMiApp={this.props.configMiApp}
              lsLiterales={this.state.lsLiterales}
            />
          </Page>
        </Popup>

        {/* DATOS DEL CONTRATO */}
        <Row className="contracts1 aligner">
          <Col
            id="contractDetail"
            width="100"
            xlarge="65"
            large="65"
            medium="65"
            small="80"
            xsmall="80"
          >
            <br />

            <div
              id="extend"
              width="100"
              large="25"
              xlarge="25"
              medium="25"
              small="40"
              xsmall="40"
              className="hidden"
            >
              <Row>
                <Col width={20} className="contract-action">
                  <Button
                    id="btnBack"
                    // iconF7="chevron_left_2"
                    onClick={(e) => this.returnCont(e)}
                    className="alignerCenter larger light"
                  >
                    {"<< "}
                    {sentenceFormat(setLiteral(this.state.lsLiterales, 101040))}
                  </Button>
                </Col>
              </Row>

              {/* CONTRATO */}
              <Block>
                <Row>
                  <Col
                    id="especial"
                    className="generalTitl left3 small"
                    width="100"
                  >
                    {removeHtmlTags(setLiteral(this.state.lsLiterales, 102026))}
                  </Col>
                </Row>
              </Block>
              <Block className="contenedorPrincipal marg1">
                <Row className="contracts2">
                  <Col
                    className="std2 smaller center"
                    id="code"
                    width="100"
                    xlarge="100"
                    large="100"
                    medium="100"
                    small="100"
                    xsmall="100"
                  ></Col>
                  <Col
                    className="contratoMain smaller center"
                    width="100"
                    xlarge="100"
                    large="100"
                    medium="100"
                    xsmall="100"
                    small="100"
                  >
                    <a id="NContrato" className="bold large "></a>
                  </Col>
                  <Col
                    width="100"
                    small="100"
                    xsmall="100"
                    large="100"
                    medium="100"
                    xlarge="100"
                  ></Col>
                </Row>
                <br></br>
                <Row className="subtitle">
                  <Col
                    width="100"
                    xlarge="33"
                    large="33"
                    medium="33"
                    xsmall="50"
                    small="50"
                    className="center"
                  >
                    <div className="subtitulos small">
                      {removeHtmlTags(
                        setLiteral(this.state.lsLiterales, 102034)
                      )}
                    </div>
                    <a className="data1 smaller bold" id="amount"></a>
                  </Col>
                  <Col
                    width="100"
                    xlarge="33"
                    large="33"
                    medium="33"
                    xsmall="50"
                    small="50"
                    className="center"
                  >
                    <div className="subtitulos small">
                      {removeHtmlTags(
                        setLiteral(this.state.lsLiterales, 102134)
                      )}
                    </div>
                    <a className="data1 smaller bold" id="liquidacion"></a>
                  </Col>
                  <Col
                    width="100"
                    xlarge="33"
                    large="33"
                    medium="33"
                    xsmall="50"
                    small="50"
                    className="center"
                  >
                    <div className="subtitulos small">
                      {removeHtmlTags(
                        setLiteral(this.state.lsLiterales, 102150)
                      )}
                    </div>
                    <a className="data1 smaller bold" id="unpaid"></a>
                  </Col>
                  <Col
                    width="100"
                    xlarge="33"
                    large="33"
                    medium="33"
                    xsmall="50"
                    small="50"
                    className="center"
                  >
                    <div className="subtitulos small">
                      {removeHtmlTags(
                        setLiteral(this.state.lsLiterales, 102028)
                      )}
                    </div>
                    <a className="data1 smaller bold" id="plazo"></a>
                  </Col>
                  <Col
                    width="100"
                    xlarge="33"
                    large="33"
                    medium="33"
                    xsmall="50"
                    small="50"
                    className="center"
                  >
                    <div className="subtitulos small">
                      {removeHtmlTags(
                        setLiteral(this.state.lsLiterales, 102029)
                      )}
                    </div>
                    <a className="data1 smaller bold" id="end"></a>
                  </Col>
                  <Col
                    width="100"
                    xlarge="33"
                    large="33"
                    medium="33"
                    xsmall="50"
                    small="50"
                    className="center"
                  >
                    <div className="subtitulos small">
                      {setLiteral(this.state.lsLiterales, 102043)}{" "}
                    </div>
                    <a className="data1 smaller bold" id="interes"></a>
                  </Col>
                  <Col
                    width="100"
                    xlarge="33"
                    large="33"
                    medium="33"
                    xsmall="50"
                    small="50"
                    className="center"
                  >
                    <div className="subtitulos small">{"Cuenta Bancaria"} </div>
                    <a className="data1 smaller bold" id="cuenta"></a>
                  </Col>
                </Row>
                <Row
                  width="100"
                  small="100"
                  xsmall="100"
                  large="100"
                  medium="100"
                  xlarge="100"
                  style={{ display: "flex", textAlign: "right" }}
                >
                  {/* BUTTON LINK DE PAGO */}
                  <Col
                    id="lPago"
                    className="hidden pagos"
                    width="100"
                    small="100"
                    xsmall="100"
                    large="100"
                    medium="100"
                    xlarge="100"
                    style={{ display: "flex", justifyContent: "right" }}
                  >
                    <Button
                      id="linkPago"
                      style={{
                        width: "400px",
                        marginRight: "75px",
                        marginBottom: "20px",
                      }}
                      className="smaller light"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ popUpLink: true });
                      }}
                    >
                      {setLiteral(this.state.lsLiterales, 102107)}
                    </Button>
                  </Col>
                </Row>
              </Block>

              {/* POPUP LINK DE PAGO */}
              <Popup
                className="demo-popup"
                id="pretty"
                opened={this.state.popUpLink}
                onPopupClosed={() => this.setState({ popUpLink: false })}
              >
                <Page>
                  <Navbar title={setLiteral(this.state.lsLiterales, 102156)}>
                    <NavRight>
                      <Link onClick={() => this.setState({ popUpLink: false })}>
                        X
                      </Link>
                    </NavRight>
                  </Navbar>
                  <Block>
                    <List inset>
                      <ListItem
                        name="radioGroup"
                        radio
                        onChange={() =>
                          this.changeViewMessage("liquidateCapital")
                        }
                        title={this.decideTitle(1)}
                      ></ListItem>

                      <ListItem
                        name="radioGroup"
                        radio
                        onChange={() => this.changeViewMessage("pastUnpaid")}
                        title={this.decideTitle(2)}
                      ></ListItem>

                      <ListItem
                        name="radioGroup"
                        radio
                        onChange={() => this.changeViewMessage("InitialEmit")}
                        title={this.decideTitle(3)}
                      ></ListItem>

                      <ListItem
                        id="rbtAdvanceAmortization"
                        name="radioGroup"
                        radio
                        onChange={() => this.changeViewMessage("LAA")}
                        title={this.decideTitle(4)}
                      ></ListItem>
                    </List>
                    {this.state.viewListAdvancedAmortizacion ? (
                      <Block style={{ marginTop: "-40px" }}>
                        <Row width="100">
                          <Col
                            width="20"
                            className="subtitulos small"
                            style={{ marginLeft: "50px", marginTop: "10px" }}
                          >
                            Monto
                          </Col>
                          <Col width="70" style={{ marginTop: "-10px" }}>
                            <Input
                              id="txtAdvanceAmortization"
                              name="txtAdvanceAmortization"
                              label="Monto"
                              type="text"
                              className="inputCustom"
                              outline
                              style={{
                                padding: "10px",
                                maxWidth: "200px",
                              }}
                              onChange={(e) => {
                                this.setState({
                                  linkAmount: String(e.target.value),
                                });
                              }}
                            />
                          </Col>
                        </Row>
                        <Row width="100" style={{ marginTop: "-30px" }}>
                          <Col width="100">
                            <List inset>
                              <ListItem
                                id="rbPagoAdelantado"
                                name="radioGroupMonto"
                                radio
                                title="Pago adelantado"
                                onChange={() => this.changeViewMessage("PA")}
                              ></ListItem>
                              <ListItem
                                id="rbAbonoCapital"
                                name="radioGroupMonto"
                                radio
                                title="Abono a capital"
                                onChange={() => this.changeViewMessage("AC")}
                                disabled={
                                  parseFloat(
                                    this.state.contractData === undefined
                                      ? 0
                                      : this.state.contractData.unexpiredPaid
                                  ) > 0
                                }
                                style={{
                                  backgroundColor:
                                    parseFloat(
                                      this.state.contractData === undefined
                                        ? 0
                                        : this.state.contractData.unexpiredPaid
                                    ) > 0
                                      ? "#C0C0C0"
                                      : "",
                                }}
                              ></ListItem>
                            </List>
                            {this.state.viewPagoAdelantadoMessage ? (
                              <span>
                                En este caso, se realizará el pago de las cuotas
                                siguientes de su crédito, adelantando el
                                capital, los intereses, los gastos de
                                administración y el seguro que aún no han
                                vencido. Tenga en cuenta que, al efectuar un
                                pago adelantado, no podrá realizar abonos a
                                capital hasta la fecha de vencimiento
                                correspondiente de las cuotas que este
                                adelantando con el pago.
                              </span>
                            ) : null}

                            {this.state.viewAbonoCapitalMessage ? (
                              <span>
                                Tenga en cuenta que un abono a capital es un
                                pago que se aplica directamente al capital y al
                                gasto de administración del crédito. Esto
                                reducirá el valor de las cuotas siguientes,
                                aunque la fecha de pago de estas se mantendrá
                                sin cambios. Realizar un abono a capital no lo
                                exime del pago de la siguiente cuota, la cual
                                deberá abonarse en la fecha establecida en su
                                crédito.
                              </span>
                            ) : null}
                          </Col>
                        </Row>
                      </Block>
                    ) : null}
                    <Row className="aligner">
                      <Col width="30">
                        <Button
                          id="btnSendLink"
                          fill
                          onClick={() => this.resendPaymentLink(true)}
                        >
                          {setLiteral(this.state.lsLiterales, 102157)}
                        </Button>
                      </Col>
                      <Col width="10"></Col>
                      <Col width="30">
                        <Button
                          id="btnPayOnline"
                          fill
                          onClick={() => this.resendPaymentLink(false)}
                        >
                          {setLiteral(this.state.lsLiterales, 102107)}
                        </Button>
                      </Col>
                    </Row>
                  </Block>
                </Page>
              </Popup>

              {/* CUADRO AMORTIZACION */}
              <Block>
                <Row>
                  <Col
                    id="especial"
                    className="generalTitl left3 small"
                    width="100"
                  >
                    Cuadro de Amortización
                  </Col>
                </Row>
              </Block>
              <Block className="contenedorPrincipal marg1">
                <Row>
                  <Col
                    id="R2"
                    width="100"
                    xlarge="100"
                    large="100"
                    small="100"
                    xsmall="100"
                  >
                    <AmortizationTable
                      installments={this.state.installments}
                      lsLiterales={this.state.lsLiterales}
                    />
                  </Col>
                </Row>
              </Block>

              {/* IMAGEN DE TARJETA DE DEBITO */}
              {false ? (
                <Block>
                  <Row className="b2 hidden" id="bank_data">
                    {/* METODO COBRO */}
                    <Col
                      id="R1"
                      width="100"
                      xlarge="50"
                      large="50"
                      small="100"
                      xsmall="100"
                    >
                      <Row>
                        <Col
                          id="especial"
                          className="generalTitl left3 small"
                          width="50"
                        >
                          {setLiteral(this.state.lsLiterales, 102158)}
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col width="5"></Col>
                        <Col width="85" className="credit_card_container">
                          <div className="tarjetaImg">
                            <Col width="80">
                              <Row
                                className="small bold leT aligner"
                                id="method"
                              ></Row>
                              <Row
                                className="small leT aligner"
                                id="card"
                              ></Row>
                              <Row>
                                <br></br>
                              </Row>
                            </Col>
                          </div>
                        </Col>
                        <Col width="10"></Col>
                      </Row>
                    </Col>
                    {/*PROXIMOS PAGOS */}
                    <Col
                      id="R2"
                      width="100"
                      xlarge="50"
                      large="50"
                      small="100"
                      xsmall="100"
                    >
                      <NextPayments
                        installments={this.state.installments}
                        lsLiterales={this.state.lsLiterales}
                      />
                    </Col>
                  </Row>
                </Block>
              ) : null}

              {/* DOCUMENTOS */}
              <Block>
                <Row>
                  {/* Documentos */}
                  <Col
                    width="100"
                    xlarge="50"
                    large="50"
                    small="100"
                    xsmall="100"
                  >
                    <Row>
                      <Col className="generalTitl small left2" width="50">
                        {setLiteral(this.state.lsLiterales, 102076) + "s"}
                      </Col>
                    </Row>
                    <br />
                    <div className="contenedorPrincipal marg1">
                      <Row>
                        <Col width="35" className=" center large">
                          {setLiteral(this.state.lsLiterales, 102152)}
                        </Col>
                        <Col width="35" className=" center large">
                          {setLiteral(this.state.lsLiterales, 102153)}
                        </Col>
                        <Col width="30" className=" center large">
                          {setLiteral(this.state.lsLiterales, 102154)}
                        </Col>
                      </Row>
                      <br />
                      <Documents docs={this.state.document} id="documentos" />
                    </div>
                  </Col>
                  {/* Pagos recibidos */}
                  <Col
                    width="100"
                    xlarge="50"
                    large="50"
                    small="100"
                    xsmall="100"
                  >
                    <Row>
                      <Col
                        id="pagosRecientes"
                        className="generalTitl small left3"
                        width="50"
                      >
                        {setLiteral(this.state.lsLiterales, 102053)}
                      </Col>
                    </Row>
                    <br />
                    <div className="contenedorPrincipal">
                      <Row>
                        <Col
                          width="33"
                          xlarge="33"
                          large="33"
                          medium="33"
                          small="33"
                          xsmall="33"
                          className="center large"
                        >
                          {setLiteral(this.state.lsLiterales, 102056)}
                        </Col>
                        <Col
                          width="33"
                          xlarge="33"
                          large="33"
                          medium="33"
                          small="33"
                          xsmall="33"
                          className="center large"
                        >
                          {setLiteral(this.state.lsLiterales, 102057)}
                        </Col>
                        <Col
                          width="33"
                          xlarge="33"
                          large="33"
                          medium="33"
                          small="33"
                          xsmall="33"
                          className="center large"
                        >
                          {setLiteral(this.state.lsLiterales, 102058)}
                        </Col>
                      </Row>
                      {/* PAGOS */}
                      {this.renderpayments(this.state.payments)}
                    </div>
                  </Col>
                </Row>
              </Block>
            </div>

            {/* CONTRATOS ACTIVOS */}
            {this.renderContracts(this.state.lsContracts)}

            {/* CONTRATOS FINALIZADOS */}
            {!this.state.viewDetail ? (
              <Row>
                <Col
                  id="titlEC"
                  className="generalTitl small left2"
                  width="100"
                  small="100"
                  xsmall="100"
                  medium="100"
                  large="100"
                  xlarge="100"
                >
                  {setLiteral(this.state.lsLiterales, 102141)}
                </Col>
                <Col
                  id="titlEC"
                  width="100"
                  small="100"
                  xsmall="100"
                  medium="100"
                  large="100"
                  xlarge="100"
                >
                  {this.renderEndedContracts(this.state.lsContracts)}
                </Col>
              </Row>
            ) : null}
            <Block />
          </Col>
        </Row>
        <Block />
      </Page>
    );
  }

  decideTitle(option) {
    let amount = "";
    if (isNullOrEmpty(this.state.contractData)) {
      amount = "0";
    } else {
      switch (option) {
        case 1:
          amount =
            setLiteral(this.state.lsLiterales, 102149) +
            `: $${numberFormat(this.state.contractData.liquidateCapital)}`;
          break;
        case 2:
          amount =
            setLiteral(this.state.lsLiterales, 102150) +
            `:$${numberFormat(this.state.contractData.pastUnpaid)}`;
          break;
        case 3:
          amount =
            setLiteral(this.state.lsLiterales, 102151) +
            `: $${numberFormat(this.state.contractData.initialEmi)}`;
          break;
        case 4:
          amount =
            "Monto entre $ " +
            numberFormat(this.state.minAmount) +
            " y $ " +
            numberFormat(this.state.maxAmount);
          break;
        default:
          amount = "";
          break;
      }
    }

    return amount;
  }

  loadContracts = (eve) => {
    eve.preventDefault();
    this.setState({ lsContracts: this.state.lsAllContracts });
  };

  renderContracts = (lsContracts) => {
    if (!lsContracts || lsContracts.length === 0) {
      return (
        <Block className="center">
          {setLiteral(this.state.lsLiterales, 102155)}
        </Block>
      );
    }

    return (
      <ContractList
        id="list"
        contracts={lsContracts}
        onDetailClick={this.renderDetailContract}
        title={setLiteral(this.state.lsLiterales, 102140)}
        lsLiterales={this.state.lsLiterales}
      />
    );
  };

  renderDetailContract = async (eve, contract) => {
    eve.preventDefault();

    this.setState({ contractData: contract, viewDetail: true });

    const paymentEndpoint = `/core/Payment/Payment/${contract.company}/${contract.contractCode}`;
    const bankDataEndpoint = `/core/Domiciliation/BankDataByContractCode/${this.configDomain.id_empresa}/${contract.contractCode}`;

    try {
      const [payments, bankData] = await Promise.all([
        consumeApi("GET", paymentEndpoint, ""),
        consumeApi("GET", bankDataEndpoint, ""),
      ]);

      this.setState({ payments: payments, bank: bankData });

      let bankCard = ""; //bankData?.bankCard;

      if (
        !bankData[0].domiType === undefined &&
        bankData[0].domiType.includes("CLABE")
      ) {
        bankCard =
          bankData[0].entityCCC +
          bankData[0].branchCCC +
          bankData[0].accountCCC +
          bankData[0].dcCCC;
        Dom7("#method").text(setLiteral(this.state.lsLiterales, 102159));
      } else {
        bankCard = bankData[0].numCard;
        Dom7("#method").text(setLiteral(this.state.lsLiterales, 102109));
      }

      const cardText = bankCard ? `********${bankCard.slice(-4)}` : "-";
      Dom7("#card").text(cardText);
      Dom7("#cuenta").text(cardText);
    } catch (error) {
      console.error("Error al obtener datos del contrato:", error);
    }

    Dom7("#titlEC, #endedC, #list").addClass("hidden");
    Dom7("#extend, #xd").removeClass("hidden");
    Dom7("#NContrato").text(contract.contractCode);
    Dom7("#amount").text(`$${numberFormat(contract.amount)}`);
    Dom7("#unpaid").text(`$${numberFormat(contract.pastUnpaid)}`);
    Dom7("#plazo").text(`${contract.term} ${contract.periodicity}`);
    Dom7("#liquidacion").text(`$${numberFormat(contract.liquidateCapital)}`);
    Dom7("#end").text(contract.startDate + " - " + contract.endDate);
    Dom7("#interes").text(`${(contract.interest * 100).toFixed(2)}%`);

    this.getDocuments(this.configDomain.id_empresa, contract.contractCode);
    this.getInstallments(contract.contractCode, this.configDomain.id_empresa);
    this.getInfoPayment(
      contract.contractCode,
      contract.contractId,
      this.configDomain.id_empresa
    );

    if (contract.stateId == 2) {
      Dom7("#bank_data").removeClass("hidden");
      if (contract.contractCode.length > 27) {
        Dom7("#code").text("Disposición:");
      }
      if (
        (contract.payment_online == 1 &&
          !isNullOrEmpty(contract.payment_online_provider) &&
          contract.payment_online_provider != "test") ||
        contract.contractCode.length > 27
      ) {
        Dom7("#lPago").removeClass("hidden");
      }
      // else {
      //     Dom7("#lPago").addClass("hidden");
      // }
    } else {
      Dom7("#lPago").addClass("hidden");
    }
  };

  returnCont = (eve) => {
    this.setState({
      linkAmount: "",
      viewListAdvancedAmortizacion: false,
      viewPagoAdelantadoMessage: false,
      viewAbonoCapitalMessage: false,
    });
    eve.preventDefault();
    Dom7("#list").removeClass("hidden");
    Dom7("#xd").addClass("hidden");
    Dom7("#titlEC").removeClass("hidden");
    Dom7("#endedC").removeClass("hidden");
    Dom7("#extend").addClass("hidden");
    Dom7("#bank_data").addClass("hidden");
    this.setState({ contractData: {}, viewDetail: false });
  };

  removeHiddenClass = () => {
    this.$$("#faqs").removeClass("hidden").addClass("modal-in");
  };

  addHiddenClass = () => {
    this.$$("#faqs").removeClass("modal-in").addClass("hidden");
    this.setState({ faqs: false });
  };

  renderEndedContracts = (lsContracts) => {
    if (lsContracts.length >= 1) {
      return lsContracts.map((contract) => {
        if (contract.stateId != 2) {
          return (
            <div id={"endedC" + contract.contractId}>
              <Block />
              <div className="contenedorSecundario">
                <Row className="contracts2">
                  <Col
                    width="100"
                    xlarge="5"
                    large="5"
                    medium="5"
                    xsmall="0"
                    small="0"
                  >
                    <Block />
                  </Col>

                  <Col
                    className='"std2 smaller left"'
                    width="100"
                    xlarge="20"
                    large="20"
                    medium="20"
                    small="100"
                    xsmall="100"
                  >
                    {removeHtmlTags(
                      setLiteral(this.state.lsLiterales, 102026)
                    ) + ":"}
                  </Col>
                  <Col
                    className="contratoMain smaller left"
                    width="100"
                    xlarge="40"
                    large="40"
                    medium="60"
                    xsmall="60"
                    small="50"
                  >
                    <a className="bold larger">{contract.contractCode}</a>
                  </Col>
                  <Col
                    width="100"
                    xlarge="35"
                    large="35"
                    medium="35"
                    small="40"
                    xsmall="40"
                    className="contract-action"
                  >
                    <Button
                      className="Cdetails alignerCenter larger light"
                      onClick={(e) => this.renderDetailContract(e, contract)}
                    >
                      DETALLES
                      {/* {sentenceFormat(setLiteral(this.lsLiterales, 102142))} */}
                      {" >>"}
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          );
        }
      });
    }
  };

  resendPaymentLink = async (sendEmail) => {
    var flag = false;
    if (this.state.viewListAdvancedAmortizacion) {
      if (
        this.state.viewAbonoCapitalMessage ||
        this.state.viewPagoAdelantadoMessage
      ) {
        if (isNullOrEmpty(this.state.linkAmount))
          f7.dialog.alert("", "Favor de ingresar el monto de pago");
        else {
          if (
            parseFloat(this.state.linkAmount) >=
              parseFloat(this.state.minAmount) &&
            parseFloat(this.state.linkAmount) <=
              parseFloat(this.state.maxAmount)
          ) {
            flag = true;
          } else {
            f7.dialog.alert(
              "",
              "Favor de ingresar un monto entre $" +
                numberFormat(this.state.minAmount) +
                " y $" +
                numberFormat(this.state.maxAmount)
            );
          }
        }
      } else {
        f7.dialog.alert("", "Favor de seleccionar el tipo de pago");
      }
    } else {
      flag = true;
    }

    if (flag) {
      if (isNullOrEmpty(this.state.linkAmount))
        f7.dialog.alert("", "Favor de seleccionar un monto de pago");
      else {
        f7.dialog.preloader();

        var date = new Date();

        const params = JSON.stringify({
          application_id: this.state.contractData.applicationId,
          reference_code: "",
          description: date.toLocaleDateString(),
          email: "",
          amount: parseFloat(this.state.linkAmount),
          user_id: "BATCH",
          language_id: this.props.configDomain.id_idioma,
          company: this.state.contractData.company,
          access_level: "2",
          test: "0",
          provider: this.state.contractData.payment_online_provider,
          contractId: this.state.contractData.contractId,
          sendEmail: sendEmail,
          cancellation: this.state.viewAbonoCapitalMessage ? "1" : "0",
        });

        //const method = "/core/Payment/NewPaymentLink";
        const method = "/notification/Emails/SendEmailLinkPago";
        const newLink = await consumeApi("POST", method, params);

        var msg = "";

        if (!String(newLink).includes("error")) {
          if (!sendEmail)
            await this.paymentOnline(
              this.state.contractData.company,
              newLink.reference,
              this.state.contractData.payment_online_provider,
              newLink.email,
              "0"
            );
          else {
            let emailSplit = newLink.email.split("@");
            let starEmail = emailSplit[0].substring(0, 2);
            let finishEmail = emailSplit[0].substring(
              emailSplit[0].length - 2,
              emailSplit[0].length
            );
            let hideEmail =
              starEmail + "*****" + finishEmail + "@" + emailSplit[1];

            msg = "Link de pago enviado al correo " + hideEmail;
          }
        } else {
          msg = "Ocurrió un error al enviar el correo";
        }

        f7.dialog.close();

        if (!isNullOrEmpty(msg))
          f7.dialog.alert(
            msg,
            setLiteral(this.state.lsLiterales, 600004019),
            () => this.setState({ popUpLink: false })
          );
      }
    }
  };

  paymentOnline = async (company, paymentId, provider, email, test) => {
    const url =
      "/notification/Emails/CreateLinkPago/" +
      company +
      "/" +
      paymentId +
      "/" +
      provider +
      "/" +
      test +
      "/" +
      email +
      "/" +
      this.props.configDomain.id_idioma +
      "/" +
      (this.state.viewAbonoCapitalMessage ? "1" : "0");

    const result = await consumeApi("GET", url, "");

    if (!result.includes("error")) {
      //window.open(result, "_blank").focus();
      window.open(result, "_self").focus();
    } else if (result.includes("Invalid payment")) {
      f7.dialog.alert(
        "Su link de pago ya no es válido, favor de solicitar otro",
        "Link inválido"
      );
    }
  };

  renderpayments(lsPayments) {
    if (this.state.payments.length <= 0) {
      return (
        <div>
          <Block />
        </div>
      );
    } else {
      if (Array.isArray(lsPayments)) {
        return lsPayments.map((payment) => {
          if (payment.pagoAplicado == 1 && payment.option == 1) {
            return (
              <Block>
                <Row>
                  <Col
                    width="33"
                    xlarge="33"
                    large="33"
                    medium="33"
                    small="33"
                    xsmall="33"
                    className="light tsmaller center"
                  >
                    {fechaRecortada(payment.issuedDate)}
                  </Col>
                  <Col
                    width="33"
                    xlarge="33"
                    large="33"
                    medium="33"
                    small="33"
                    xsmall="33"
                    className="light tsmaller center"
                  >
                    {fechaRecortada(payment.paymentDate)}
                  </Col>
                  <Col
                    width="33"
                    xlarge="33"
                    large="33"
                    medium="33"
                    small="33"
                    xsmall="33"
                    className="light tsmaller center"
                  >
                    {newAmount(payment.amount)}
                  </Col>
                </Row>
              </Block>
            );
          }
        });
      } else {
        return (
          <div>
            <Block />
          </div>
        );
      }
    }
  }

  loopQuestions = (lsFaqs) => {
    return lsFaqs.map((faq) => {
      return this.renderAccordionItem(
        faq.faqId,
        faq.question,
        faq.answer,
        faq.additional
      );
    });
  };

  renderAccordionItem = (id, question, answer, additional) => {
    return (
      <ListItem key={"faq" + id} accordionItem title={question}>
        <AccordionContent>
          <Block>
            <div>{parse(answer)}</div>
            <div>
              {additional && additional.length > 0
                ? additional.map((add) => {
                    return this.renderAccordionItem(
                      add.faqId,
                      add.question,
                      add.answer,
                      add.additional
                    );
                  })
                : ""}
            </div>
          </Block>
        </AccordionContent>
      </ListItem>
    );
  };

  //#region Callapi
  getQuestions = async () => {
    f7.dialog.preloader(setLiteral(this.state.lsLiterales, 101030));
    const method = "/miapp/MiApp/InfoFAQ/" + this.configDomain.id_empresa;
    const faqs = await consumeApi("get", method, "");

    if (!String(faqs).includes("error")) this.setState({ lsFaqs: faqs });

    f7.dialog.close();
  };

  getDocuments = (domain, contract) => {
    if (contract.length > 27) {
      contract = contract.substring(0, 27);
    }

    const method =
      "/core/Document/DocumentByContractCode/" + domain + "/" + contract;

    const doc = consumeApi("get", method, "");

    doc
      .then((response) => {
        this.setState({ document: response });
      })
      .catch((error) => {
        console.error("Error al obtener los documentos:", error);
      });
  };

  getInstallments = async (contract, domain) => {
    const method =
      "/core/Installment/InstallmentByContractCode/" + domain + "/" + contract;

    try {
      // Esperamos la respuesta de la API de manera asíncrona
      const response = await consumeApi("get", method, "");

      // Actualizamos el estado con los datos obtenidos
      this.setState({ installments: response });
    } catch (error) {
      // Manejo de errores en caso de que falle la API
      console.error("Error al obtener installments:", error);
    }
  };

  getInfoPayment = async (contract_code, contract, domain) => {
    const method = "/integration/Payment/infoPayment";

    try {
      var type = contract_code.includes("D0") ? "7" : "2";

      var params = JSON.stringify({
        company: domain,
        folio: contract,
        id_terminal: "",
        local_date: "",
        trx_no: "",
        type: type,
      });

      // Esperamos la respuesta de la API de manera asíncrona
      const response = await consumeApi("POST", method, params);

      const jsonData = JSON.parse(response);

      // Actualizamos el estado con los datos obtenidos
      this.setState({ minAmount: jsonData.paymentAmount });
      this.setState({ maxAmount: jsonData.balanceAmount });
    } catch (error) {
      // Manejo de errores en caso de que falle la API
      console.error("Error al obtener installments:", error);
    }
  };

  getUserData = async () => {
    f7.dialog.preloader(setLiteral(this.state.lsLiterales, 101030));

    const method =
      "/core/Customer/CustomerByClientId/" +
      this.configDomain.id_empresa +
      "/" +
      this.user.clientId;
    const user = await consumeApi("GET", method, "");

    this.setState({ userData: user[0] });

    f7.dialog.close();
  };

  getContracts = async () => {
    f7.dialog.preloader(setLiteral(this.props.Literales, 101030));
    const method =
      "/core/Contract/ContractByClientId/" +
      this.configDomain.id_empresa +
      "/" +
      this.user.clientId; // "/C000000837"
    const contracts = await consumeApi("get", method, "");

    if (contracts.length > 3) {
      this.setState({ height: "auto" });
    }

    if (typeof contracts == "object" && contracts.length > 0)
      this.setState({ lsContracts: contracts, lsAllContracts: contracts });

    f7.dialog.close();
  };
  //#endregion Callapi

  changeViewMessage = (item) => {
    if (item == "PA") {
      this.setState({
        viewAbonoCapitalMessage: false,
        viewPagoAdelantadoMessage: true,
      });
    }
    if (item == "AC") {
      this.setState({
        viewAbonoCapitalMessage: true,
        viewPagoAdelantadoMessage: false,
      });
    }
    if (item == "LAA") {
      this.setState({
        viewListAdvancedAmortizacion: true,
      });
    }
    if (item == "InitialEmit") {
      this.setState({
        viewAbonoCapitalMessage: false,
        viewPagoAdelantadoMessage: false,
        viewListAdvancedAmortizacion: false,
        linkAmount: String(this.state.contractData.initialEmi),
      });
    }
    if (item == "liquidateCapital") {
      this.setState({
        viewAbonoCapitalMessage: false,
        viewPagoAdelantadoMessage: false,
        viewListAdvancedAmortizacion: false,
        linkAmount: String(this.state.contractData.liquidateCapital),
      });
    }
    if (item == "pastUnpaid") {
      this.setState({
        viewAbonoCapitalMessage: false,
        viewPagoAdelantadoMessage: false,
        viewListAdvancedAmortizacion: false,
        linkAmount: String(this.state.contractData.pastUnpaid),
      });
    }
  };
}
